// @generated by protoc-gen-es v2.10.1 with parameter "target=ts"
// @generated from file cortado/v1/subscriptions.proto (package cortado.v1, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { OrganizationUserType } from "./organizations_pb";
import { file_cortado_v1_organizations } from "./organizations_pb";
import type { Timestamp } from "@bufbuild/protobuf/wkt";
import { file_google_protobuf_timestamp } from "@bufbuild/protobuf/wkt";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file cortado/v1/subscriptions.proto.
 */
export const file_cortado_v1_subscriptions: GenFile = /*@__PURE__*/
  fileDesc("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", [file_cortado_v1_organizations, file_google_protobuf_timestamp]);

/**
 * Subscription represents an organization's subscription
 *
 * @generated from message cortado.v1.Subscription
 */
export type Subscription = Message<"cortado.v1.Subscription"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string organization_id = 2;
   */
  organizationId: string;

  /**
   * Deprecated compatibility alias retained while deployed clients migrate
   * from the former provider-neutralization rollout. Servers populate both
   * this field and stripe_subscription_id with the same Stripe identifier.
   *
   * @generated from field: string polar_subscription_id = 3 [deprecated = true];
   * @deprecated
   */
  polarSubscriptionId: string;

  /**
   * @generated from field: cortado.v1.SubscriptionStatusEnum status = 4;
   */
  status: SubscriptionStatusEnum;

  /**
   * @generated from field: google.protobuf.Timestamp current_period_start = 5;
   */
  currentPeriodStart?: Timestamp;

  /**
   * @generated from field: google.protobuf.Timestamp current_period_end = 6;
   */
  currentPeriodEnd?: Timestamp;

  /**
   * @generated from field: optional google.protobuf.Timestamp canceled_at = 7;
   */
  canceledAt?: Timestamp;

  /**
   * @generated from field: optional string product_name = 8;
   */
  productName?: string;

  /**
   * @generated from field: optional int64 amount_cents = 9;
   */
  amountCents?: bigint;

  /**
   * @generated from field: optional string currency = 10;
   */
  currency?: string;

  /**
   * @generated from field: optional google.protobuf.Timestamp created_at = 11;
   */
  createdAt?: Timestamp;

  /**
   * @generated from field: optional google.protobuf.Timestamp updated_at = 12;
   */
  updatedAt?: Timestamp;

  /**
   * @generated from field: string stripe_subscription_id = 13;
   */
  stripeSubscriptionId: string;
};

/**
 * Describes the message cortado.v1.Subscription.
 * Use `create(SubscriptionSchema)` to create a new message.
 */
export const SubscriptionSchema: GenMessage<Subscription> = /*@__PURE__*/
  messageDesc(file_cortado_v1_subscriptions, 0);

/**
 * PaymentRecord represents a past Stripe invoice payment.
 *
 * @generated from message cortado.v1.PaymentRecord
 */
export type PaymentRecord = Message<"cortado.v1.PaymentRecord"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: int64 amount_cents = 2;
   */
  amountCents: bigint;

  /**
   * @generated from field: string currency = 3;
   */
  currency: string;

  /**
   * @generated from field: string status = 4;
   */
  status: string;

  /**
   * @generated from field: google.protobuf.Timestamp created_at = 5;
   */
  createdAt?: Timestamp;

  /**
   * @generated from field: optional string description = 6;
   */
  description?: string;

  /**
   * receipt_lines is the in-app receipt breakdown for this payment,
   * projected server-side from the order.created payload. The $0.00
   * base-seat line is suppressed server-side.
   *
   * @generated from field: repeated cortado.v1.ReceiptLine receipt_lines = 7;
   */
  receiptLines: ReceiptLine[];
};

/**
 * Describes the message cortado.v1.PaymentRecord.
 * Use `create(PaymentRecordSchema)` to create a new message.
 */
export const PaymentRecordSchema: GenMessage<PaymentRecord> = /*@__PURE__*/
  messageDesc(file_cortado_v1_subscriptions, 1);

/**
 * ReceiptLine is one line of an in-app receipt breakdown for a payment.
 *
 * @generated from message cortado.v1.ReceiptLine
 */
export type ReceiptLine = Message<"cortado.v1.ReceiptLine"> & {
  /**
   * @generated from field: string label = 1;
   */
  label: string;

  /**
   * @generated from field: int32 quantity = 20;
   */
  quantity: number;

  /**
   * @generated from field: int64 unit_amount_cents = 21;
   */
  unitAmountCents: bigint;

  /**
   * @generated from field: int64 amount_cents = 22;
   */
  amountCents: bigint;

  /**
   * @generated from field: bool is_base_plan = 50;
   */
  isBasePlan: boolean;

  /**
   * has_unit_amount is false when unit_amount_cents is not a known,
   * meaningful per-unit price - an inexact proration division, or a
   * discount line - and must not be rendered as a real $0.00.
   *
   * @generated from field: bool has_unit_amount = 51;
   */
  hasUnitAmount: boolean;
};

/**
 * Describes the message cortado.v1.ReceiptLine.
 * Use `create(ReceiptLineSchema)` to create a new message.
 */
export const ReceiptLineSchema: GenMessage<ReceiptLine> = /*@__PURE__*/
  messageDesc(file_cortado_v1_subscriptions, 2);

/**
 * PlanOption is one purchasable plan+interval combination, as offered to a
 * specific organization (ListPlanOptions only returns the assigned plan's 3
 * intervals when plan_is_assigned is true on OrganizationBillingState).
 *
 * @generated from message cortado.v1.PlanOption
 */
export type PlanOption = Message<"cortado.v1.PlanOption"> & {
  /**
   * @generated from field: cortado.v1.PlanKeyEnum plan_key = 1;
   */
  planKey: PlanKeyEnum;

  /**
   * @generated from field: cortado.v1.BillingIntervalEnum billing_interval = 2;
   */
  billingInterval: BillingIntervalEnum;

  /**
   * @generated from field: int64 price_cents = 20;
   */
  priceCents: bigint;

  /**
   * @generated from field: string price_formatted = 21;
   */
  priceFormatted: string;

  /**
   * @generated from field: int32 interval_months = 22;
   */
  intervalMonths: number;

  /**
   * @generated from field: int64 seat_price_cents = 23;
   */
  seatPriceCents: bigint;

  /**
   * Organization-specific quote for the first selected term. These fields
   * include the current billable-seat count and any applied rate exception;
   * clients must not reconstruct the amount from price_cents.
   *
   * @generated from field: int64 quoted_first_charge_cents = 24;
   */
  quotedFirstChargeCents: bigint;

  /**
   * @generated from field: string quoted_first_charge_formatted = 25;
   */
  quotedFirstChargeFormatted: string;

  /**
   * Optional explanatory copy such as "$228.00 base + 1 additional seat x
   * $19.00/seat - $50.00 discount". Empty when the base is the whole quote.
   *
   * @generated from field: string quoted_first_charge_breakdown = 26;
   */
  quotedFirstChargeBreakdown: string;

  /**
   * @generated from field: int32 quoted_billable_seats = 27;
   */
  quotedBillableSeats: number;

  /**
   * @generated from field: int64 quoted_seat_charge_cents = 28;
   */
  quotedSeatChargeCents: bigint;

  /**
   * @generated from field: int64 quoted_discount_cents = 29;
   */
  quotedDiscountCents: bigint;

  /**
   * @generated from field: bool is_assigned = 50;
   */
  isAssigned: boolean;

  /**
   * @generated from field: bool is_current = 51;
   */
  isCurrent: boolean;

  /**
   * @generated from field: optional string savings_label = 52;
   */
  savingsLabel?: string;
};

/**
 * Describes the message cortado.v1.PlanOption.
 * Use `create(PlanOptionSchema)` to create a new message.
 */
export const PlanOptionSchema: GenMessage<PlanOption> = /*@__PURE__*/
  messageDesc(file_cortado_v1_subscriptions, 3);

/**
 * SeatUser is one row of an organization's seat usage breakdown.
 *
 * @generated from message cortado.v1.SeatUser
 */
export type SeatUser = Message<"cortado.v1.SeatUser"> & {
  /**
   * @generated from field: string user_id = 1;
   */
  userId: string;

  /**
   * @generated from field: string full_name = 20;
   */
  fullName: string;

  /**
   * @generated from field: string email = 21;
   */
  email: string;

  /**
   * @generated from field: optional google.protobuf.Timestamp activated_at = 30;
   */
  activatedAt?: Timestamp;

  /**
   * @generated from field: bool is_billable = 50;
   */
  isBillable: boolean;

  /**
   * is_payment_blocked marks a most-recently-activated user held pending or
   * disabled by a failed added-seat payment (R-92). Still counted toward
   * desired_seats until the owner explicitly removes them.
   *
   * @generated from field: bool is_payment_blocked = 51;
   */
  isPaymentBlocked: boolean;

  /**
   * user_type is the membership type. EVENT_STAFF users are listed but never
   * billable.
   *
   * @generated from field: cortado.v1.OrganizationUserType user_type = 52;
   */
  userType: OrganizationUserType;
};

/**
 * Describes the message cortado.v1.SeatUser.
 * Use `create(SeatUserSchema)` to create a new message.
 */
export const SeatUserSchema: GenMessage<SeatUser> = /*@__PURE__*/
  messageDesc(file_cortado_v1_subscriptions, 4);

/**
 * OrganizationBillingState is the single message the frontend needs for every
 * billing gate decision - the org's billing/access state plus everything a
 * billing UI surface displays.
 *
 * @generated from message cortado.v1.OrganizationBillingState
 */
export type OrganizationBillingState = Message<"cortado.v1.OrganizationBillingState"> & {
  /**
   * Core identification (1-9)
   *
   * @generated from field: string organization_id = 1;
   */
  organizationId: string;

  /**
   * Billing/access state (10-19)
   *
   * @generated from field: cortado.v1.BillingAccessStateEnum state = 10;
   */
  state: BillingAccessStateEnum;

  /**
   * @generated from field: google.protobuf.Timestamp state_since = 11;
   */
  stateSince?: Timestamp;

  /**
   * Assigned plan and selected billing interval (20-29)
   *
   * R-71 - display, not choice
   *
   * @generated from field: cortado.v1.PlanKeyEnum assigned_plan_key = 20;
   */
  assignedPlanKey: PlanKeyEnum;

  /**
   * true => UI must not offer other plans
   *
   * @generated from field: bool plan_is_assigned = 21;
   */
  planIsAssigned: boolean;

  /**
   * @generated from field: cortado.v1.BillingIntervalEnum selected_interval = 22;
   */
  selectedInterval: BillingIntervalEnum;

  /**
   * Trial / first charge (30-39)
   *
   * @generated from field: optional google.protobuf.Timestamp trial_started_at = 30;
   */
  trialStartedAt?: Timestamp;

  /**
   * R-25 - always set during a trial
   *
   * @generated from field: optional google.protobuf.Timestamp first_charge_at = 31;
   */
  firstChargeAt?: Timestamp;

  /**
   * first_charge_amount_formatted is resolved server-side from plan +
   * interval + seats, e.g. "$158.00 plus applicable tax". The tax qualifier
   * (R-110) is baked into the formatted string so no caller can drop it.
   *
   * @generated from field: string first_charge_amount_formatted = 32;
   */
  firstChargeAmountFormatted: string;

  /**
   * effective_trial_days is the backend policy Stripe Checkout uses for a new
   * trial. provisional_first_charge_at is the backend-clock estimate before
   * checkout fixes first_charge_at on the subscription.
   *
   * @generated from field: int32 effective_trial_days = 33;
   */
  effectiveTrialDays: number;

  /**
   * @generated from field: optional google.protobuf.Timestamp provisional_first_charge_at = 34;
   */
  provisionalFirstChargeAt?: Timestamp;

  /**
   * Access window timers and seats (40-49)
   *
   * R-54/R-67
   *
   * @generated from field: optional google.protobuf.Timestamp read_only_until = 40;
   */
  readOnlyUntil?: Timestamp;

  /**
   * R-48
   *
   * @generated from field: optional google.protobuf.Timestamp grace_ends_at = 42;
   */
  graceEndsAt?: Timestamp;

  /**
   * 2
   *
   * @generated from field: int32 included_seats = 43;
   */
  includedSeats: number;

  /**
   * MAX(2, active users)
   *
   * @generated from field: int32 billable_seats = 44;
   */
  billableSeats: number;

  /**
   * @generated from field: optional int32 pending_seat_reduction_to = 45;
   */
  pendingSeatReductionTo?: number;

  /**
   * R-92
   *
   * @generated from field: bool seat_payment_failed = 46;
   */
  seatPaymentFailed: boolean;

  /**
   * Flags (50-59)
   * can_manage_billing is true when the actor holds PermissionBillingManage
   * (DEC-44); drives the two variants of the hard gate.
   *
   * @generated from field: bool can_manage_billing = 50;
   */
  canManageBilling: boolean;

  /**
   * R-83 override active - show support screen, not checkout
   *
   * @generated from field: bool is_suspended = 51;
   */
  isSuspended: boolean;

  /**
   * trial_available is true when trial_used_at IS NULL; drives "start free
   * trial" vs "your subscription starts today" copy (R-30/R-31).
   *
   * @generated from field: bool trial_available = 52;
   */
  trialAvailable: boolean;

  /**
   * blocked_capabilities is a machine-readable read-only capability list for
   * UI affordances.
   *
   * @generated from field: repeated string blocked_capabilities = 53;
   */
  blockedCapabilities: string[];

  /**
   * @generated from field: cortado.v1.BillingAccessProfileEnum access_profile = 54;
   */
  accessProfile: BillingAccessProfileEnum;

  /**
   * @generated from field: cortado.v1.BillingAccessReasonEnum access_reason = 55;
   */
  accessReason: BillingAccessReasonEnum;

  /**
   * enforcement_bypassed exposes the backend emergency override while
   * retaining the underlying billing state for diagnostics.
   *
   * @generated from field: bool enforcement_bypassed = 56;
   */
  enforcementBypassed: boolean;

  /**
   * @generated from field: optional google.protobuf.Timestamp billing_launch_at = 61;
   */
  billingLaunchAt?: Timestamp;

  /**
   * Volume trial (70-79). Set while a volume trial can still end the trial:
   * before checkout and while trialing.
   *
   * @generated from field: optional cortado.v1.VolumeTrialProgress volume_trial = 70;
   */
  volumeTrial?: VolumeTrialProgress;
};

/**
 * Describes the message cortado.v1.OrganizationBillingState.
 * Use `create(OrganizationBillingStateSchema)` to create a new message.
 */
export const OrganizationBillingStateSchema: GenMessage<OrganizationBillingState> = /*@__PURE__*/
  messageDesc(file_cortado_v1_subscriptions, 5);

/**
 * VolumeTrialProgress is a volume trial's terms and how far the organization
 * has got. The trial ends at threshold_cents of Stripe Connect volume, or at
 * first_charge_at (backstop_days after it started), whichever comes first.
 *
 * @generated from message cortado.v1.VolumeTrialProgress
 */
export type VolumeTrialProgress = Message<"cortado.v1.VolumeTrialProgress"> & {
  /**
   * @generated from field: string rate_exception_id = 1;
   */
  rateExceptionId: string;

  /**
   * @generated from field: int64 threshold_cents = 2;
   */
  thresholdCents: bigint;

  /**
   * Connect volume since the trial started, net of refunds. Zero before
   * checkout starts the trial.
   *
   * @generated from field: int64 volume_cents = 3;
   */
  volumeCents: bigint;

  /**
   * @generated from field: int32 backstop_days = 4;
   */
  backstopDays: number;

  /**
   * Set once the threshold was reached and the trial is ending.
   *
   * @generated from field: optional google.protobuf.Timestamp reached_at = 5;
   */
  reachedAt?: Timestamp;
};

/**
 * Describes the message cortado.v1.VolumeTrialProgress.
 * Use `create(VolumeTrialProgressSchema)` to create a new message.
 */
export const VolumeTrialProgressSchema: GenMessage<VolumeTrialProgress> = /*@__PURE__*/
  messageDesc(file_cortado_v1_subscriptions, 6);

/**
 * GetOrganizationSubscription retrieves the subscription for an organization
 *
 * @generated from message cortado.v1.GetOrganizationSubscriptionRequest
 */
export type GetOrganizationSubscriptionRequest = Message<"cortado.v1.GetOrganizationSubscriptionRequest"> & {
  /**
   * @generated from field: string organization_id = 1;
   */
  organizationId: string;
};

/**
 * Describes the message cortado.v1.GetOrganizationSubscriptionRequest.
 * Use `create(GetOrganizationSubscriptionRequestSchema)` to create a new message.
 */
export const GetOrganizationSubscriptionRequestSchema: GenMessage<GetOrganizationSubscriptionRequest> = /*@__PURE__*/
  messageDesc(file_cortado_v1_subscriptions, 7);

/**
 * @generated from message cortado.v1.GetOrganizationSubscriptionResponse
 */
export type GetOrganizationSubscriptionResponse = Message<"cortado.v1.GetOrganizationSubscriptionResponse"> & {
  /**
   * @generated from field: bool has_subscription = 1;
   */
  hasSubscription: boolean;

  /**
   * @generated from field: optional cortado.v1.Subscription subscription = 2;
   */
  subscription?: Subscription;
};

/**
 * Describes the message cortado.v1.GetOrganizationSubscriptionResponse.
 * Use `create(GetOrganizationSubscriptionResponseSchema)` to create a new message.
 */
export const GetOrganizationSubscriptionResponseSchema: GenMessage<GetOrganizationSubscriptionResponse> = /*@__PURE__*/
  messageDesc(file_cortado_v1_subscriptions, 8);

/**
 * GetPaymentHistory retrieves payment history for an organization
 *
 * @generated from message cortado.v1.GetPaymentHistoryRequest
 */
export type GetPaymentHistoryRequest = Message<"cortado.v1.GetPaymentHistoryRequest"> & {
  /**
   * @generated from field: string organization_id = 1;
   */
  organizationId: string;
};

/**
 * Describes the message cortado.v1.GetPaymentHistoryRequest.
 * Use `create(GetPaymentHistoryRequestSchema)` to create a new message.
 */
export const GetPaymentHistoryRequestSchema: GenMessage<GetPaymentHistoryRequest> = /*@__PURE__*/
  messageDesc(file_cortado_v1_subscriptions, 9);

/**
 * @generated from message cortado.v1.GetPaymentHistoryResponse
 */
export type GetPaymentHistoryResponse = Message<"cortado.v1.GetPaymentHistoryResponse"> & {
  /**
   * @generated from field: repeated cortado.v1.PaymentRecord payments = 1;
   */
  payments: PaymentRecord[];
};

/**
 * Describes the message cortado.v1.GetPaymentHistoryResponse.
 * Use `create(GetPaymentHistoryResponseSchema)` to create a new message.
 */
export const GetPaymentHistoryResponseSchema: GenMessage<GetPaymentHistoryResponse> = /*@__PURE__*/
  messageDesc(file_cortado_v1_subscriptions, 10);

/**
 * CreateCheckoutSession creates a Stripe Checkout Session for subscribing.
 *
 * @generated from message cortado.v1.CreateCheckoutSessionRequest
 */
export type CreateCheckoutSessionRequest = Message<"cortado.v1.CreateCheckoutSessionRequest"> & {
  /**
   * @generated from field: string organization_id = 1;
   */
  organizationId: string;

  /**
   * @generated from field: string success_url = 2;
   */
  successUrl: string;

  /**
   * @generated from field: cortado.v1.PlanKeyEnum plan_key = 3;
   */
  planKey: PlanKeyEnum;

  /**
   * @generated from field: cortado.v1.BillingIntervalEnum billing_interval = 4;
   */
  billingInterval: BillingIntervalEnum;

  /**
   * Origin of the page starting Stripe Checkout (window.location.origin).
   *
   * @generated from field: string embed_origin = 5;
   */
  embedOrigin: string;
};

/**
 * Describes the message cortado.v1.CreateCheckoutSessionRequest.
 * Use `create(CreateCheckoutSessionRequestSchema)` to create a new message.
 */
export const CreateCheckoutSessionRequestSchema: GenMessage<CreateCheckoutSessionRequest> = /*@__PURE__*/
  messageDesc(file_cortado_v1_subscriptions, 11);

/**
 * @generated from message cortado.v1.CreateCheckoutSessionResponse
 */
export type CreateCheckoutSessionResponse = Message<"cortado.v1.CreateCheckoutSessionResponse"> & {
  /**
   * @generated from field: string checkout_url = 1;
   */
  checkoutUrl: string;

  /**
   * @generated from field: string checkout_id = 2;
   */
  checkoutId: string;

  /**
   * @generated from field: google.protobuf.Timestamp expires_at = 3;
   */
  expiresAt?: Timestamp;

  /**
   * @generated from field: string client_secret = 4;
   */
  clientSecret: string;
};

/**
 * Describes the message cortado.v1.CreateCheckoutSessionResponse.
 * Use `create(CreateCheckoutSessionResponseSchema)` to create a new message.
 */
export const CreateCheckoutSessionResponseSchema: GenMessage<CreateCheckoutSessionResponse> = /*@__PURE__*/
  messageDesc(file_cortado_v1_subscriptions, 12);

/**
 * ReconcileCheckoutSession performs tenant-scoped lost-webhook recovery for a
 * checkout that Cortado created for this organization. It performs provider
 * reads only and projects authoritative state through the normal lifecycle.
 *
 * @generated from message cortado.v1.ReconcileCheckoutSessionRequest
 */
export type ReconcileCheckoutSessionRequest = Message<"cortado.v1.ReconcileCheckoutSessionRequest"> & {
  /**
   * @generated from field: string organization_id = 1;
   */
  organizationId: string;

  /**
   * @generated from field: string checkout_id = 2;
   */
  checkoutId: string;
};

/**
 * Describes the message cortado.v1.ReconcileCheckoutSessionRequest.
 * Use `create(ReconcileCheckoutSessionRequestSchema)` to create a new message.
 */
export const ReconcileCheckoutSessionRequestSchema: GenMessage<ReconcileCheckoutSessionRequest> = /*@__PURE__*/
  messageDesc(file_cortado_v1_subscriptions, 13);

/**
 * @generated from message cortado.v1.ReconcileCheckoutSessionResponse
 */
export type ReconcileCheckoutSessionResponse = Message<"cortado.v1.ReconcileCheckoutSessionResponse"> & {
  /**
   * @generated from field: cortado.v1.OrganizationBillingState billing_state = 1;
   */
  billingState?: OrganizationBillingState;

  /**
   * @generated from field: bool checkout_confirmed = 2;
   */
  checkoutConfirmed: boolean;
};

/**
 * Describes the message cortado.v1.ReconcileCheckoutSessionResponse.
 * Use `create(ReconcileCheckoutSessionResponseSchema)` to create a new message.
 */
export const ReconcileCheckoutSessionResponseSchema: GenMessage<ReconcileCheckoutSessionResponse> = /*@__PURE__*/
  messageDesc(file_cortado_v1_subscriptions, 14);

/**
 * GetCustomerPortalURL returns the Stripe customer portal URL for managing a subscription.
 *
 * @generated from message cortado.v1.GetCustomerPortalURLRequest
 */
export type GetCustomerPortalURLRequest = Message<"cortado.v1.GetCustomerPortalURLRequest"> & {
  /**
   * @generated from field: string organization_id = 1;
   */
  organizationId: string;
};

/**
 * Describes the message cortado.v1.GetCustomerPortalURLRequest.
 * Use `create(GetCustomerPortalURLRequestSchema)` to create a new message.
 */
export const GetCustomerPortalURLRequestSchema: GenMessage<GetCustomerPortalURLRequest> = /*@__PURE__*/
  messageDesc(file_cortado_v1_subscriptions, 15);

/**
 * @generated from message cortado.v1.GetCustomerPortalURLResponse
 */
export type GetCustomerPortalURLResponse = Message<"cortado.v1.GetCustomerPortalURLResponse"> & {
  /**
   * @generated from field: string portal_url = 1;
   */
  portalUrl: string;
};

/**
 * Describes the message cortado.v1.GetCustomerPortalURLResponse.
 * Use `create(GetCustomerPortalURLResponseSchema)` to create a new message.
 */
export const GetCustomerPortalURLResponseSchema: GenMessage<GetCustomerPortalURLResponse> = /*@__PURE__*/
  messageDesc(file_cortado_v1_subscriptions, 16);

/**
 * GetSubscriptionProduct returns the eligible subscription product for an organization
 *
 * @generated from message cortado.v1.GetSubscriptionProductRequest
 */
export type GetSubscriptionProductRequest = Message<"cortado.v1.GetSubscriptionProductRequest"> & {
  /**
   * @generated from field: string organization_id = 1;
   */
  organizationId: string;
};

/**
 * Describes the message cortado.v1.GetSubscriptionProductRequest.
 * Use `create(GetSubscriptionProductRequestSchema)` to create a new message.
 */
export const GetSubscriptionProductRequestSchema: GenMessage<GetSubscriptionProductRequest> = /*@__PURE__*/
  messageDesc(file_cortado_v1_subscriptions, 17);

/**
 * @generated from message cortado.v1.GetSubscriptionProductResponse
 */
export type GetSubscriptionProductResponse = Message<"cortado.v1.GetSubscriptionProductResponse"> & {
  /**
   * @generated from field: string product_name = 1;
   */
  productName: string;

  /**
   * @generated from field: int64 price_cents = 2;
   */
  priceCents: bigint;

  /**
   * @generated from field: string currency = 3;
   */
  currency: string;

  /**
   * @generated from field: int32 trial_days = 4;
   */
  trialDays: number;
};

/**
 * Describes the message cortado.v1.GetSubscriptionProductResponse.
 * Use `create(GetSubscriptionProductResponseSchema)` to create a new message.
 */
export const GetSubscriptionProductResponseSchema: GenMessage<GetSubscriptionProductResponse> = /*@__PURE__*/
  messageDesc(file_cortado_v1_subscriptions, 18);

/**
 * GetOrganizationBillingState retrieves the org billing/access state - the
 * message the frontend needs for every billing gate decision.
 *
 * @generated from message cortado.v1.GetOrganizationBillingStateRequest
 */
export type GetOrganizationBillingStateRequest = Message<"cortado.v1.GetOrganizationBillingStateRequest"> & {
  /**
   * @generated from field: string organization_id = 1;
   */
  organizationId: string;
};

/**
 * Describes the message cortado.v1.GetOrganizationBillingStateRequest.
 * Use `create(GetOrganizationBillingStateRequestSchema)` to create a new message.
 */
export const GetOrganizationBillingStateRequestSchema: GenMessage<GetOrganizationBillingStateRequest> = /*@__PURE__*/
  messageDesc(file_cortado_v1_subscriptions, 19);

/**
 * @generated from message cortado.v1.GetOrganizationBillingStateResponse
 */
export type GetOrganizationBillingStateResponse = Message<"cortado.v1.GetOrganizationBillingStateResponse"> & {
  /**
   * @generated from field: cortado.v1.OrganizationBillingState billing_state = 1;
   */
  billingState?: OrganizationBillingState;
};

/**
 * Describes the message cortado.v1.GetOrganizationBillingStateResponse.
 * Use `create(GetOrganizationBillingStateResponseSchema)` to create a new message.
 */
export const GetOrganizationBillingStateResponseSchema: GenMessage<GetOrganizationBillingStateResponse> = /*@__PURE__*/
  messageDesc(file_cortado_v1_subscriptions, 20);

/**
 * ListPlanOptions lists the purchasable plan+interval combinations for an
 * organization. Only the assigned plan's 3 intervals are returned when
 * plan_is_assigned is true on OrganizationBillingState (R-71).
 *
 * @generated from message cortado.v1.ListPlanOptionsRequest
 */
export type ListPlanOptionsRequest = Message<"cortado.v1.ListPlanOptionsRequest"> & {
  /**
   * @generated from field: string organization_id = 1;
   */
  organizationId: string;
};

/**
 * Describes the message cortado.v1.ListPlanOptionsRequest.
 * Use `create(ListPlanOptionsRequestSchema)` to create a new message.
 */
export const ListPlanOptionsRequestSchema: GenMessage<ListPlanOptionsRequest> = /*@__PURE__*/
  messageDesc(file_cortado_v1_subscriptions, 21);

/**
 * @generated from message cortado.v1.ListPlanOptionsResponse
 */
export type ListPlanOptionsResponse = Message<"cortado.v1.ListPlanOptionsResponse"> & {
  /**
   * @generated from field: repeated cortado.v1.PlanOption plan_options = 1;
   */
  planOptions: PlanOption[];
};

/**
 * Describes the message cortado.v1.ListPlanOptionsResponse.
 * Use `create(ListPlanOptionsResponseSchema)` to create a new message.
 */
export const ListPlanOptionsResponseSchema: GenMessage<ListPlanOptionsResponse> = /*@__PURE__*/
  messageDesc(file_cortado_v1_subscriptions, 22);

/**
 * PreviewPlanChange tells the UI whether a plan/interval change would apply
 * now or at renewal, and what it costs (R-35, R-36).
 *
 * @generated from message cortado.v1.PreviewPlanChangeRequest
 */
export type PreviewPlanChangeRequest = Message<"cortado.v1.PreviewPlanChangeRequest"> & {
  /**
   * @generated from field: string organization_id = 1;
   */
  organizationId: string;

  /**
   * @generated from field: cortado.v1.PlanKeyEnum plan_key = 2;
   */
  planKey: PlanKeyEnum;

  /**
   * @generated from field: cortado.v1.BillingIntervalEnum billing_interval = 3;
   */
  billingInterval: BillingIntervalEnum;
};

/**
 * Describes the message cortado.v1.PreviewPlanChangeRequest.
 * Use `create(PreviewPlanChangeRequestSchema)` to create a new message.
 */
export const PreviewPlanChangeRequestSchema: GenMessage<PreviewPlanChangeRequest> = /*@__PURE__*/
  messageDesc(file_cortado_v1_subscriptions, 23);

/**
 * @generated from message cortado.v1.PreviewPlanChangeResponse
 */
export type PreviewPlanChangeResponse = Message<"cortado.v1.PreviewPlanChangeResponse"> & {
  /**
   * @generated from field: google.protobuf.Timestamp effective_at = 1;
   */
  effectiveAt?: Timestamp;

  /**
   * @generated from field: int64 proration_amount_cents = 2;
   */
  prorationAmountCents: bigint;

  /**
   * @generated from field: bool applies_immediately = 3;
   */
  appliesImmediately: boolean;

  /**
   * @generated from field: string description = 4;
   */
  description: string;
};

/**
 * Describes the message cortado.v1.PreviewPlanChangeResponse.
 * Use `create(PreviewPlanChangeResponseSchema)` to create a new message.
 */
export const PreviewPlanChangeResponseSchema: GenMessage<PreviewPlanChangeResponse> = /*@__PURE__*/
  messageDesc(file_cortado_v1_subscriptions, 24);

/**
 * ChangeSubscriptionPlan changes an organization's plan and/or billing
 * interval (R-33..R-36).
 *
 * @generated from message cortado.v1.ChangeSubscriptionPlanRequest
 */
export type ChangeSubscriptionPlanRequest = Message<"cortado.v1.ChangeSubscriptionPlanRequest"> & {
  /**
   * @generated from field: string organization_id = 1;
   */
  organizationId: string;

  /**
   * @generated from field: cortado.v1.PlanKeyEnum plan_key = 2;
   */
  planKey: PlanKeyEnum;

  /**
   * @generated from field: cortado.v1.BillingIntervalEnum billing_interval = 3;
   */
  billingInterval: BillingIntervalEnum;
};

/**
 * Describes the message cortado.v1.ChangeSubscriptionPlanRequest.
 * Use `create(ChangeSubscriptionPlanRequestSchema)` to create a new message.
 */
export const ChangeSubscriptionPlanRequestSchema: GenMessage<ChangeSubscriptionPlanRequest> = /*@__PURE__*/
  messageDesc(file_cortado_v1_subscriptions, 25);

/**
 * @generated from message cortado.v1.ChangeSubscriptionPlanResponse
 */
export type ChangeSubscriptionPlanResponse = Message<"cortado.v1.ChangeSubscriptionPlanResponse"> & {
  /**
   * @generated from field: cortado.v1.OrganizationBillingState billing_state = 1;
   */
  billingState?: OrganizationBillingState;
};

/**
 * Describes the message cortado.v1.ChangeSubscriptionPlanResponse.
 * Use `create(ChangeSubscriptionPlanResponseSchema)` to create a new message.
 */
export const ChangeSubscriptionPlanResponseSchema: GenMessage<ChangeSubscriptionPlanResponse> = /*@__PURE__*/
  messageDesc(file_cortado_v1_subscriptions, 26);

/**
 * CancelSubscription always schedules cancellation at period end
 * (cancel_at_period_end: true); immediate closure is admin-only (R-53).
 *
 * @generated from message cortado.v1.CancelSubscriptionRequest
 */
export type CancelSubscriptionRequest = Message<"cortado.v1.CancelSubscriptionRequest"> & {
  /**
   * @generated from field: string organization_id = 1;
   */
  organizationId: string;

  /**
   * @generated from field: string cancellation_reason = 2;
   */
  cancellationReason: string;

  /**
   * @generated from field: optional string comment = 3;
   */
  comment?: string;
};

/**
 * Describes the message cortado.v1.CancelSubscriptionRequest.
 * Use `create(CancelSubscriptionRequestSchema)` to create a new message.
 */
export const CancelSubscriptionRequestSchema: GenMessage<CancelSubscriptionRequest> = /*@__PURE__*/
  messageDesc(file_cortado_v1_subscriptions, 27);

/**
 * @generated from message cortado.v1.CancelSubscriptionResponse
 */
export type CancelSubscriptionResponse = Message<"cortado.v1.CancelSubscriptionResponse"> & {
  /**
   * @generated from field: cortado.v1.OrganizationBillingState billing_state = 1;
   */
  billingState?: OrganizationBillingState;
};

/**
 * Describes the message cortado.v1.CancelSubscriptionResponse.
 * Use `create(CancelSubscriptionResponseSchema)` to create a new message.
 */
export const CancelSubscriptionResponseSchema: GenMessage<CancelSubscriptionResponse> = /*@__PURE__*/
  messageDesc(file_cortado_v1_subscriptions, 28);

/**
 * ResumeSubscription reverses a scheduled cancellation before the paid term
 * expires (R-75), clearing cancel_at_period_end.
 *
 * @generated from message cortado.v1.ResumeSubscriptionRequest
 */
export type ResumeSubscriptionRequest = Message<"cortado.v1.ResumeSubscriptionRequest"> & {
  /**
   * @generated from field: string organization_id = 1;
   */
  organizationId: string;
};

/**
 * Describes the message cortado.v1.ResumeSubscriptionRequest.
 * Use `create(ResumeSubscriptionRequestSchema)` to create a new message.
 */
export const ResumeSubscriptionRequestSchema: GenMessage<ResumeSubscriptionRequest> = /*@__PURE__*/
  messageDesc(file_cortado_v1_subscriptions, 29);

/**
 * @generated from message cortado.v1.ResumeSubscriptionResponse
 */
export type ResumeSubscriptionResponse = Message<"cortado.v1.ResumeSubscriptionResponse"> & {
  /**
   * @generated from field: cortado.v1.OrganizationBillingState billing_state = 1;
   */
  billingState?: OrganizationBillingState;
};

/**
 * Describes the message cortado.v1.ResumeSubscriptionResponse.
 * Use `create(ResumeSubscriptionResponseSchema)` to create a new message.
 */
export const ResumeSubscriptionResponseSchema: GenMessage<ResumeSubscriptionResponse> = /*@__PURE__*/
  messageDesc(file_cortado_v1_subscriptions, 30);

/**
 * GetSeatUsage returns an organization's seat usage and billing breakdown
 * (R-85..R-92).
 *
 * @generated from message cortado.v1.GetSeatUsageRequest
 */
export type GetSeatUsageRequest = Message<"cortado.v1.GetSeatUsageRequest"> & {
  /**
   * @generated from field: string organization_id = 1;
   */
  organizationId: string;
};

/**
 * Describes the message cortado.v1.GetSeatUsageRequest.
 * Use `create(GetSeatUsageRequestSchema)` to create a new message.
 */
export const GetSeatUsageRequestSchema: GenMessage<GetSeatUsageRequest> = /*@__PURE__*/
  messageDesc(file_cortado_v1_subscriptions, 31);

/**
 * @generated from message cortado.v1.GetSeatUsageResponse
 */
export type GetSeatUsageResponse = Message<"cortado.v1.GetSeatUsageResponse"> & {
  /**
   * @generated from field: int32 included_seats = 1;
   */
  includedSeats: number;

  /**
   * @generated from field: int32 active_users = 2;
   */
  activeUsers: number;

  /**
   * @generated from field: int32 billable_seats = 3;
   */
  billableSeats: number;

  /**
   * @generated from field: int32 pending_reduction_to = 4;
   */
  pendingReductionTo: number;

  /**
   * @generated from field: int64 seat_price_cents = 5;
   */
  seatPriceCents: bigint;

  /**
   * @generated from field: int64 next_charge_estimate_cents = 6;
   */
  nextChargeEstimateCents: bigint;

  /**
   * @generated from field: repeated cortado.v1.SeatUser seat_users = 7;
   */
  seatUsers: SeatUser[];

  /**
   * event_staff_users counts accepted, active, non-internal Event Staff.
   *
   * @generated from field: int32 event_staff_users = 8;
   */
  eventStaffUsers: number;
};

/**
 * Describes the message cortado.v1.GetSeatUsageResponse.
 * Use `create(GetSeatUsageResponseSchema)` to create a new message.
 */
export const GetSeatUsageResponseSchema: GenMessage<GetSeatUsageResponse> = /*@__PURE__*/
  messageDesc(file_cortado_v1_subscriptions, 32);

/**
 * SubscriptionStatusEnum represents the status of a Stripe subscription.
 *
 * @generated from enum cortado.v1.SubscriptionStatusEnum
 */
export enum SubscriptionStatusEnum {
  /**
   * @generated from enum value: SUBSCRIPTION_STATUS_UNSPECIFIED = 0;
   */
  SUBSCRIPTION_STATUS_UNSPECIFIED = 0,

  /**
   * @generated from enum value: SUBSCRIPTION_STATUS_INCOMPLETE = 1;
   */
  SUBSCRIPTION_STATUS_INCOMPLETE = 1,

  /**
   * @generated from enum value: SUBSCRIPTION_STATUS_TRIALING = 2;
   */
  SUBSCRIPTION_STATUS_TRIALING = 2,

  /**
   * @generated from enum value: SUBSCRIPTION_STATUS_ACTIVE = 3;
   */
  SUBSCRIPTION_STATUS_ACTIVE = 3,

  /**
   * @generated from enum value: SUBSCRIPTION_STATUS_PAST_DUE = 4;
   */
  SUBSCRIPTION_STATUS_PAST_DUE = 4,

  /**
   * @generated from enum value: SUBSCRIPTION_STATUS_CANCELED = 5;
   */
  SUBSCRIPTION_STATUS_CANCELED = 5,

  /**
   * @generated from enum value: SUBSCRIPTION_STATUS_UNPAID = 6;
   */
  SUBSCRIPTION_STATUS_UNPAID = 6,

  /**
   * @generated from enum value: SUBSCRIPTION_STATUS_REVOKED = 7;
   */
  SUBSCRIPTION_STATUS_REVOKED = 7,

  /**
   * @generated from enum value: SUBSCRIPTION_STATUS_INCOMPLETE_EXPIRED = 8;
   */
  SUBSCRIPTION_STATUS_INCOMPLETE_EXPIRED = 8,

  /**
   * @generated from enum value: SUBSCRIPTION_STATUS_PAUSED = 9;
   */
  SUBSCRIPTION_STATUS_PAUSED = 9,
}

/**
 * Describes the enum cortado.v1.SubscriptionStatusEnum.
 */
export const SubscriptionStatusEnumSchema: GenEnum<SubscriptionStatusEnum> = /*@__PURE__*/
  enumDesc(file_cortado_v1_subscriptions, 0);

/**
 * BillingAccessStateEnum is the org billing/access state machine's state
 * (subscriptions.org_billing_state.billing_state). It is distinct from
 * SubscriptionStatusEnum, which mirrors Stripe's subscription lifecycle
 * verbatim: this enum is our backend's derived access decision.
 *
 * @generated from enum cortado.v1.BillingAccessStateEnum
 */
export enum BillingAccessStateEnum {
  /**
   * @generated from enum value: BILLING_ACCESS_STATE_UNSPECIFIED = 0;
   */
  BILLING_ACCESS_STATE_UNSPECIFIED = 0,

  /**
   * @generated from enum value: BILLING_ACCESS_STATE_NONE = 1;
   */
  BILLING_ACCESS_STATE_NONE = 1,

  /**
   * @generated from enum value: BILLING_ACCESS_STATE_TRIALING = 3;
   */
  BILLING_ACCESS_STATE_TRIALING = 3,

  /**
   * @generated from enum value: BILLING_ACCESS_STATE_ACTIVE = 4;
   */
  BILLING_ACCESS_STATE_ACTIVE = 4,

  /**
   * @generated from enum value: BILLING_ACCESS_STATE_GRACE = 5;
   */
  BILLING_ACCESS_STATE_GRACE = 5,

  /**
   * @generated from enum value: BILLING_ACCESS_STATE_PAUSED_PAYMENT = 6;
   */
  BILLING_ACCESS_STATE_PAUSED_PAYMENT = 6,

  /**
   * @generated from enum value: BILLING_ACCESS_STATE_READ_ONLY = 7;
   */
  BILLING_ACCESS_STATE_READ_ONLY = 7,

  /**
   * @generated from enum value: BILLING_ACCESS_STATE_EXPIRED = 8;
   */
  BILLING_ACCESS_STATE_EXPIRED = 8,

  /**
   * @generated from enum value: BILLING_ACCESS_STATE_COMP = 9;
   */
  BILLING_ACCESS_STATE_COMP = 9,
}

/**
 * Describes the enum cortado.v1.BillingAccessStateEnum.
 */
export const BillingAccessStateEnumSchema: GenEnum<BillingAccessStateEnum> = /*@__PURE__*/
  enumDesc(file_cortado_v1_subscriptions, 1);

/**
 * BillingAccessProfileEnum is the backend-derived shape of access available
 * to an organization. Clients must use this profile and access_reason rather
 * than deriving access from BillingAccessStateEnum.
 *
 * @generated from enum cortado.v1.BillingAccessProfileEnum
 */
export enum BillingAccessProfileEnum {
  /**
   * @generated from enum value: BILLING_ACCESS_PROFILE_ENUM_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: BILLING_ACCESS_PROFILE_ENUM_FULL = 1;
   */
  FULL = 1,

  /**
   * @generated from enum value: BILLING_ACCESS_PROFILE_ENUM_RESTRICTED = 2;
   */
  RESTRICTED = 2,

  /**
   * @generated from enum value: BILLING_ACCESS_PROFILE_ENUM_BILLING_ONLY = 3;
   */
  BILLING_ONLY = 3,

  /**
   * @generated from enum value: BILLING_ACCESS_PROFILE_ENUM_ONBOARDING = 4;
   */
  ONBOARDING = 4,
}

/**
 * Describes the enum cortado.v1.BillingAccessProfileEnum.
 */
export const BillingAccessProfileEnumSchema: GenEnum<BillingAccessProfileEnum> = /*@__PURE__*/
  enumDesc(file_cortado_v1_subscriptions, 2);

/**
 * BillingAccessReasonEnum explains the backend-derived access profile and is
 * stable enough for client navigation, banners, and typed denial handling.
 *
 * @generated from enum cortado.v1.BillingAccessReasonEnum
 */
export enum BillingAccessReasonEnum {
  /**
   * @generated from enum value: BILLING_ACCESS_REASON_ENUM_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: BILLING_ACCESS_REASON_ENUM_ONBOARDING_INCOMPLETE = 1;
   */
  ONBOARDING_INCOMPLETE = 1,

  /**
   * @generated from enum value: BILLING_ACCESS_REASON_ENUM_PRELAUNCH_SUBSCRIPTION_OPTIONAL = 2;
   */
  PRELAUNCH_SUBSCRIPTION_OPTIONAL = 2,

  /**
   * @generated from enum value: BILLING_ACCESS_REASON_ENUM_SUBSCRIPTION_REQUIRED = 3;
   */
  SUBSCRIPTION_REQUIRED = 3,

  /**
   * @generated from enum value: BILLING_ACCESS_REASON_ENUM_PAYMENT_PAUSED = 4;
   */
  PAYMENT_PAUSED = 4,

  /**
   * @generated from enum value: BILLING_ACCESS_REASON_ENUM_PAID_READ_ONLY = 5;
   */
  PAID_READ_ONLY = 5,

  /**
   * @generated from enum value: BILLING_ACCESS_REASON_ENUM_SUBSCRIPTION_EXPIRED = 6;
   */
  SUBSCRIPTION_EXPIRED = 6,

  /**
   * @generated from enum value: BILLING_ACCESS_REASON_ENUM_SUSPENDED = 7;
   */
  SUSPENDED = 7,
}

/**
 * Describes the enum cortado.v1.BillingAccessReasonEnum.
 */
export const BillingAccessReasonEnumSchema: GenEnum<BillingAccessReasonEnum> = /*@__PURE__*/
  enumDesc(file_cortado_v1_subscriptions, 3);

/**
 * PlanKeyEnum identifies one of the three priced plans. Every plan carries the
 * identical feature set - the only difference between them is price.
 *
 * @generated from enum cortado.v1.PlanKeyEnum
 */
export enum PlanKeyEnum {
  /**
   * @generated from enum value: PLAN_KEY_UNSPECIFIED = 0;
   */
  PLAN_KEY_UNSPECIFIED = 0,

  /**
   * @generated from enum value: PLAN_KEY_FOUNDER = 1;
   */
  PLAN_KEY_FOUNDER = 1,

  /**
   * @generated from enum value: PLAN_KEY_CCC = 2;
   */
  PLAN_KEY_CCC = 2,

  /**
   * @generated from enum value: PLAN_KEY_STANDARD = 3;
   */
  PLAN_KEY_STANDARD = 3,
}

/**
 * Describes the enum cortado.v1.PlanKeyEnum.
 */
export const PlanKeyEnumSchema: GenEnum<PlanKeyEnum> = /*@__PURE__*/
  enumDesc(file_cortado_v1_subscriptions, 4);

/**
 * BillingIntervalEnum identifies one of the three billing cadences available
 * per plan (monthly, 6-month pay-in-full, 12-month pay-in-full).
 *
 * Deliberately no TrialKindEnum: every account - new signup and transitioning
 * beta user alike - gets the same configured trial policy, so a kind
 * distinction would carry exactly one meaningful value. Nothing in this proto,
 * the schema, or the UI branches on trial kind.
 *
 * @generated from enum cortado.v1.BillingIntervalEnum
 */
export enum BillingIntervalEnum {
  /**
   * @generated from enum value: BILLING_INTERVAL_UNSPECIFIED = 0;
   */
  BILLING_INTERVAL_UNSPECIFIED = 0,

  /**
   * @generated from enum value: BILLING_INTERVAL_MONTHLY = 1;
   */
  BILLING_INTERVAL_MONTHLY = 1,

  /**
   * @generated from enum value: BILLING_INTERVAL_SEMIANNUAL = 2;
   */
  BILLING_INTERVAL_SEMIANNUAL = 2,

  /**
   * @generated from enum value: BILLING_INTERVAL_ANNUAL = 3;
   */
  BILLING_INTERVAL_ANNUAL = 3,
}

/**
 * Describes the enum cortado.v1.BillingIntervalEnum.
 */
export const BillingIntervalEnumSchema: GenEnum<BillingIntervalEnum> = /*@__PURE__*/
  enumDesc(file_cortado_v1_subscriptions, 5);

